import { Info } from 'lucide-react'
import { InfoPopover } from '@/components/ui/InfoPopover'
import { cn } from '@/lib/utils/helpers'
import type { DocumentStatusInfoIconProps, DocumentStatusSource } from '../types'

const SECTIONS: Array<{
  key: keyof DocumentStatusSource
  label: string
  colorClass: string
}> = [
  { key: 'rental_status_required', label: 'Missing', colorClass: 'text-[#2A5AD2]' },
  { key: 'resident_default_rejected', label: 'Incomplete', colorClass: 'text-red-600' },
  { key: 'resident_default_uploaded', label: 'Uploaded', colorClass: 'text-[#CC9D42]' },
  { key: 'resident_default_received', label: 'Received', colorClass: 'text-green-600' },
]

export function DocumentStatusInfoIcon({ item, className }: DocumentStatusInfoIconProps) {
  const groups = SECTIONS.map((s) => ({ ...s, items: item[s.key] ?? [] })).filter(
    (s) => Array.isArray(s.items) && s.items.length > 0,
  )
  if (groups.length === 0) return null

  return (
    <span className={cn('inline-flex items-center gap-1 align-middle', className)}>
      {groups.map((group) => (
        <InfoPopover
          key={group.label}
          align="end"
          maxWidth={360}
          className="pl-4"
          contentClassName="text-left"
          content={
            <div className="space-y-1">
              <div className="font-semibold text-slate-900">{group.label}</div>
              <ul className="list-disc pl-4 text-left text-slate-800">
                {group.items.map((doc) => (
                  <li key={doc}>{doc}</li>
                ))}
              </ul>
            </div>
          }
        >
          <button
            type="button"
            aria-label={`${group.label} document status details`}
            className={cn(
              'inline-flex items-center justify-center rounded-full p-0.5 leading-none transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-blue-200',
              group.colorClass,
            )}
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </InfoPopover>
      ))}
    </span>
  )
}
